<a href="/">
  <span class="brand-name">TYMES4.</span><span class="brand-small">Backoffice</span>
</a>
@if (version) {
  <div class="brand-version text-white-50">{{ version }}</div>
}
